import { atom, RecoilState } from "recoil";
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist();

type BBBEEScorecard = {
    scorecardId: string;
    scorecardName: string;
    scorecardTypeId?: number;
}

export const BBBEEScorecardAtom: RecoilState<BBBEEScorecard> = atom<BBBEEScorecard>({
    key: 'BBBEEScorecardAtom',
    default: {
        scorecardId: "",
        scorecardName: ""
    } as BBBEEScorecard,
    effects_UNSTABLE: [persistAtom]
});